export { default } from './Seo';